import PropTypes from 'prop-types';
import React from 'react';
import {Link} from 'react-router';

import { formatPosition, formatRaceDetails, getProfileHelpers } from 'modules/HorseRacing/utils';

require('./PersonProfileTable.scss');

export default function PersonProfileTable({profile = {}, rideLabel, earlyEntries = false}) {
  const {
    run_future_entries: future_entries,
    run_previous_results: previous_results
  } = profile;

  const { results, formatDateTime, buildHref } = getProfileHelpers({ future_entries, previous_results }, earlyEntries);

  if (!earlyEntries) {
    results.forEach(r => r.formattedPosition = formatPosition(r.horse_entry));
  }

  return (
    <div>
      <table className="default-table person-profile-results-table">
        <thead>
          <tr>
            <th>Date {earlyEntries && "/ Time"}</th>
            {!earlyEntries && <th>Pos</th>}
            <th>{rideLabel}</th>
            {!earlyEntries && <th className="person-profile-results-table-race-type">Type</th>}
            <th>Race Details</th>
            <th>S<span className="full-text">tarting </span>P<span className="full-text">rice</span></th>
          </tr>
        </thead>
        <tbody>
          {results.map(({
              horse_summary: {
                name: ride
              },
              formattedPosition,
              horse_entry,
              horse_entry: {
                race_id,
                odds,
                run_type
              }
            }) => (<tr key={`${race_id}-${ride}`}>
              <td>
                <Link to={buildHref(horse_entry)}
                  className="person-profile-racing-form-racecard-link">
                  {formatDateTime(horse_entry)}
                </Link>
              </td>
              {!earlyEntries && <td>{formattedPosition}</td>}
              <td>{ride}</td>
              {!earlyEntries && <td className="person-profile-results-table-race-type">{run_type}</td>}
              <td>{formatRaceDetails(horse_entry)}</td>
              <td>{odds}</td>
            </tr>)
          )}
        </tbody>
      </table>
      {!results.length && <p className="person-profile-results-table-empty">No {earlyEntries ? "entries" : "results"}</p>}
    </div>
  );
}

PersonProfileTable.propTypes = {
  earlyEntries: PropTypes.bool,
  profile: PropTypes.object.isRequired,
  rideLabel: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/Profiles/PersonProfileTable.js